module.exports = __webpack_public_path__ + "static/img/zhuanyituandui.6db5bcd6.png";